import { render, staticRenderFns } from "./ListInvoicesView.vue?vue&type=template&id=55a35978&scoped=true&"
import script from "./ListInvoicesView.vue?vue&type=script&lang=js&"
export * from "./ListInvoicesView.vue?vue&type=script&lang=js&"
import style0 from "./ListInvoicesView.vue?vue&type=style&index=0&id=55a35978&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a35978",
  null
  
)

export default component.exports